import React from 'react'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import Link from '../Link'

const OsFeatures = (props) => {
  const { ctaText, ctaUrl } = props
  return (
    <div className="wrapper">
      <GradientBorder className={styles.mobileOnlyGrad} height="1px" />
      <div className={styles.container}>
        <div className={styles.features}>
          {props.components.map((comp, idx) => (
            <div className={styles.feature} key={idx}>
              <GatsbyImage
                image={comp.gatsbyImageData}
                alt={comp?.image?.description}
                className={styles.featureImage}
                imgStyle={{ objectFit: 'contain' }}
              />
              <h3 className={styles.featureTitle}>{comp.title}</h3>
              <div className={styles.featureSubtitle}>
                {comp.subtitle.subtitle}
              </div>
            </div>
          ))}
        </div>
        {ctaUrl && ctaText && (
          <div className={styles.talkToSales}>
            <Link to={ctaUrl}>
              <Button className={styles.tts}>{ctaText}</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default OsFeatures
